import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { ProductsManagementFiltersContext } from "../../../../../contexts/ProductsManagementFiltersProvider";
import {
  decimalMoney,
  formatStoresToId,
  prettyMoney
} from "../../../../../helpers";
import { useSelectedStores } from "../../../../../hooks/stores";
import { getLowTurnProducts } from "../../../../../services/product-management";
import InfoTooltip from "../../../../Common/InfoTooltip";
import Pagination from "../../../../Common/Pagination";

export default function BrandProducts({ brand }) {
  const { weeksInterval, category, subCategory, segment } = useContext(
    ProductsManagementFiltersContext
  );
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(false);
  const selectedStores = useSelectedStores();

  const [currentPage, setCurrentPage] = useState(1);
  const [cachedPages, setCachedPages] = useState({});
  const [pages, setPages] = useState(0);

  const onChangePaginationHandler = (e, page) => {
    setCurrentPage(page);
  };

  const cachePage = (page, orders) => {
    setCachedPages({ ...cachedPages, [page]: orders });
  };

  const fetchProducts = async (page = 1) => {
    setLoading(true);

    let stores = null;

    if (selectedStores.length) {
      stores = formatStoresToId(selectedStores).join(",");
    }

    try {
      const { data } = await getLowTurnProducts(
        page,
        stores,
        weeksInterval,
        brand,
        category,
        subCategory,
        segment
      );
      cachePage(page, data.data);
      setProducts(data.data);
      setPages(data.pages);
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  };

  useEffect(() => {
    // if (cachedPages.hasOwnProperty(currentPage)) {
    //   setProducts(cachedPages[currentPage]);
    //   return;
    // }

    fetchProducts(currentPage);
  }, [currentPage]);

  useEffect(() => {
    setCachedPages({});
    setCurrentPage(1);
  }, [selectedStores, weeksInterval, category, subCategory, segment]);

  return (
    <div className="p-10 mb-10 rounded" style={{ backgroundColor: "#f7f7f7" }}>
      {loading && (
        <div className="loading-container">
          <CircularProgress />
        </div>
      )}

      {!loading && !products?.length && (
        <div className="empty-list">Nenhum produto encontrado.</div>
      )}

      {!loading && !!products?.length && (
        <>
          <div className="overflow-auto">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Código</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Item</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Categoria</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Venda QTD</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Venda R$</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Venda a CMV R$</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Lucro Bruto R$</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Estoque QTD</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Estoque R$</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">MB%</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">Markup</span>
                  </TableCell>
                  <TableCell style={{ border: 0, padding: 6, minWidth: 100 }}>
                    <span className="font-size-lg">VMM</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!loading &&
                  products?.map(product => (
                    <TableRow key={product.id}>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">
                          {product.sku || "-"}
                        </span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">{product.name}</span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">
                          {product.category || "-"}
                        </span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">
                          {product.total_sold}
                        </span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">
                          {decimalMoney(product.total_value_without_discounts)}
                        </span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">
                          {decimalMoney(product.cmv)}
                        </span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">
                          {decimalMoney(product.gross_profit)}
                        </span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg badge badge-warning">
                          {product.in_stock}
                        </span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">
                          {decimalMoney(product.stock_value)}
                        </span>
                        <InfoTooltip
                          text={`Custo unitário: ${prettyMoney(
                            product.cost_value
                          )}`}
                          margin="ml-2 mb-1"
                        />
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">
                          {parseFloat(product.gross_margin).toFixed(2)}
                        </span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg">
                          {product.mark_up && +product.mark_up > 0
                            ? parseFloat(product.mark_up).toFixed(2)
                            : "-"}
                        </span>
                      </TableCell>
                      <TableCell style={{ border: 0, padding: 6 }}>
                        <span className="font-size-lg badge badge-success">
                          {Math.round(parseFloat(product.vmm)).toFixed(0)}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </>
      )}

      {!loading && !!products?.length && (
        <div className="mt-10">
          <Pagination
            page={currentPage}
            count={pages}
            onChange={onChangePaginationHandler}
          />
        </div>
      )}
    </div>
  );
}
